/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Schedule_Day_Of_Month_LabelInputs */



/**
* | output |
* | --- |
* | "Day of the month" |
*
* @param {Agent_Schedule_Day_Of_Month_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedule_day_of_month_label = /** @type {((inputs?: Agent_Schedule_Day_Of_Month_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedule_Day_Of_Month_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tag im Monat")
	return /** @type {LocalizedString} */ ("Day of the month")
});